import React from 'react';
import { Carousel } from 'antd';
import { gameMetaArray } from 'db/data';
import { Button, Card, Flex, Typography } from 'antd';
import { HomeOutlined, LoadingOutlined, SettingFilled, SmileOutlined, SyncOutlined } from '@ant-design/icons';
import "App.css";
import { useNavigate } from 'react-router-dom';


const thumbnailStyle: React.CSSProperties = {
	borderRadius: '10px',
	width: '100%',
	objectFit: 'cover',
};

const cardStyle: React.CSSProperties = {
	width: "95%",
	maxWidth: "1080px",
	margin: "auto"
};


export const GameCards: React.FC = () => {
	const navigateTo = useNavigate();
	
	return (
		<Flex vertical gap={50} style={{ width: '960', marginTop: 150 }}>
			{gameMetaArray.map((item, index) => (
				<Card key={index} hoverable style={cardStyle} onClick={() => navigateTo(`/games/${item.url}`)}>
					<Flex vertical justify="space-between">
						<img className="shadow" style={thumbnailStyle} src={String(item.imgPath)} />
						<Flex align="center" justify="space-between" gap={100}>
							<Flex vertical>
								<Typography.Title level={3}>{item.title}</Typography.Title>
								<Typography.Paragraph>{item.description}</Typography.Paragraph>
								<Flex gap={5}>
									{item.platformIcons.map((icon, index) => (
										<div key={index}>{icon}</div>
									))}
								</Flex>
							</Flex>
						</Flex>
					</Flex>
				</Card>
			))}
		</Flex>
	);};
